module.exports = __webpack_public_path__ + "static/media/7-item-c.6aa21356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/7-item-c.jpg
// module id = 1208
// module chunks = 33